// @ts-nocheck
import React, { Children, cloneElement } from 'react';
import classNames from 'classnames';
import styles from '../style.module.css';

function List(props : any) {
  const { children, className } = props;

  return (
    <ul className={classNames(styles.tabList, className)} role="tablist">
      {Children.map(children, (child, index) => (
        cloneElement(child, { index })
      ))}
    </ul>
  );
}

List.defaultProps = {
  className: null,
};


export default List;
